<template>
  <v-layout column fill-height class="batch-card" v-if="batch && batch.id">
    <v-flex grow>
      <div class="text-xs-center font-weight-regular headline">Batch Details</div>
      <div class="text-xs-center caption">ID: {{batch.id}}</div>

      <v-layout column class="px-3 py-2">
        <v-layout row class="header px-2 py-2 font-weight-medium">
          <v-flex grow>Supplier Lot Number</v-flex>
          <v-flex shrink>Details</v-flex>
        </v-layout>
        <v-layout align-center class="px-2" v-for="lot in batch.lots" :key="lot.id">
          <v-flex grow>{{lot.id}}</v-flex>
          <v-flex shrink>
            <v-btn @click="goToLot(lot.id)" icon>
              <v-icon dark color="#378e07" class=" my-1">info</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-flex>

    <v-flex shrink v-if="batch.blockchain">
      <v-layout column>
        <div class="text-xs-center">Secured by Hyperledger Sawtooth</div>
        <a :href="batch.blockchain.state" class="text-xs-center hash">Hash:{{batch.blockchain.address}}</a>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'BatchCard',
  props: {
    batch: Object
  },
  computed: mapGetters({
  }),
  methods: {
    goToLot (lotId) {
      this.$emit('view-lot-details', lotId)
    }
  }
}
</script>

<style lang="scss" scoped>
.infos-container{
  padding: 10px 25px;
}

.batch-card{
  min-width: 350px;
}

.header{
  background: #fafafa;
  font-size: 14px;
}

.label{
  color: #333333;
  font-size: 12px;
}

.hash {
  font-family: monospace;
  word-break: break-all;
  text-decoration: none;
  color: #333333;
}

.value{
  background: white;
  font-size: 16px;
}
</style>
